import { FC } from 'react';
import { DayPicker, UI } from 'react-day-picker';
import 'react-day-picker/style.css';
import { ru } from 'react-day-picker/locale';
import './calendar.scss';
import { CustomCaptionLabel } from '~/widgets/CalendarByCss/customComponents/CustomCaptionLabel';
import { CustomWeekday } from '~/widgets/CalendarByCss/customComponents/CustomWeekday';

interface Props {
  mode: 'single' | 'multiple';
  changeDate?: (date: Date | Date[], triggerDate?: Date) => void;
  currentDate?: Date | Date[] | undefined;
  booking?: Date[];
  available?: 'always' | 'period' | 'sometimes' | 'blocked';
}

const today = new Date();
//Отключает все прошедшие дни. После надо будет дополнить датами с бэка. После вынести из компоненты
const prevDays = Array.from({ length: today.getDate() - 1 }, (_, i) => {
  return new Date(today.getFullYear(), today.getMonth(), i + 1);
});

export const CalendarByCss: FC<Props> = ({
  mode,
  changeDate,
  currentDate,
  available,
  booking,
}) => {
  const disabledDays = [
    ...prevDays,
    ...(booking ? booking.map((date) => new Date(date)) : []),
  ];

  const onSelectHandler = (date: Date | Date[], trigger?: Date) => {
    if (changeDate) {
      if (available === 'period') {
        changeDate(date, trigger);
      } else {
        changeDate(date);
      }
    }
  };

  return (
    <div className={'relative'}>
      <DayPicker
        showOutsideDays={false}
        numberOfMonths={3}
        components={{
          CaptionLabel: CustomCaptionLabel,
          Weekday: CustomWeekday,
        }}
        mode={mode}
        min={mode !== 'single' ? 1 : undefined}
        selected={currentDate}
        onSelect={(date: Date[], trigger: Date) =>
          onSelectHandler(date, trigger)
        }
        modifiers={{ reserved: booking?.map((date) => new Date(date)) }}
        modifiersClassNames={{
          reserved:
            available === 'blocked' ? 'rdp-reserved_white' : 'rdp-reserved',
        }}
        disabled={available !== 'always' && disabledDays}
        locale={ru}
        classNames={{
          day: available === 'blocked' ? 'rdp-disabled rdp-day' : 'rdp-day',
          [UI.DayButton]:
            available === 'blocked'
              ? 'rdp-day_button blocked '
              : 'rdp-day_button',
        }}
      />
    </div>
  );
};
